import { Flex } from 'components/common/styles'
import { BACKGROUND_REDESIGN, PURPLE, PURPLE_RGB } from 'constants/colors'
import styled, { css } from 'styled-components'

export const StyledDateRange = styled(Flex)<{ isOpen: boolean }>`
  cursor: pointer;
  padding: 8px 12px;
  background: ${BACKGROUND_REDESIGN};
  border-radius: 8px;
  height: 36px;
  line-height: 20px;
  ${({ isOpen }) =>
    isOpen &&
    css`
      color: ${PURPLE};
      background: rgba(${PURPLE_RGB}, 0.15);
      border-color: rgba(${PURPLE_RGB}, 0.15);
      border-radius: 8px;

      .MuiInput-input {
        color: ${PURPLE};
      }

      > svg:last-child {
        transform: rotate(180deg);
      }
    `}

  > svg {
    &:first-child {
      min-width: 18px;
      height: 18px;
      margin-right: 8px;
    }

    &:last-child {
      min-width: 9px;
      height: 6px;
      margin-left: 8px;
    }
  }

  .MuiFormLabel-root {
    left: -35px;
    right: -30px;
    top: -8px;
    bottom: -8px;
    transform: none;
    margin: 0;
    opacity: 0;
    cursor: pointer;
  }

  .MuiInput-root {
    margin: 0;

    &:before,
    &:after {
      display: none;
    }
  }

  .MuiInputBase-input {
    padding: 0;
    cursor: pointer;
  }
`
